export default __webpack_public_path__ + "static/object-larger-dont-4128ea95020d9a0ff971d504b9fbc70987bc4e5522b2ba229c5ff168638daa85.png";